import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildLegalHead } from "@/lib/legalSeo";

export const Route = createFileRoute("/terms-of-use")({
  head: () => buildLegalHead("/terms-of-use"),
  component: lazyRouteComponent(() => import("@/pages/TermsOfUse")),
});
